import {Button, Row, Col, Modal, Form, Collapse} from 'react-bootstrap';
import { iminioBackend } from '../../../api/iminio_provider';
import { useState, useEffect, useRef } from 'react';
import IminioButton from '../../iminio_comps/buttons/IminioButton'

function IminioInterventionPhotoButton({ photos=[], disabled, onClickUpload, onDelete, interventionId, enableDelete, enableEditPhotos}) {

    const [message, setMessage] = useState(false)
    const [loadingArray, setLoadingArray] = useState([])
    const [showImageModal, setShowImageModal] = useState(false);
    const [showNewImageModal, setShowNewImageModal] = useState(false);
    const [isNewImageLoading, setIsNewImageLoading] = useState(false);
    const [isEditingLoading, setIsEditingLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [imageToDelete, setImageToDelete] = useState("");
    const [currShownImage, setCurrShowImage] = useState("");
    const [currShownImageId, setCurrShowImageId] = useState("");
    const [currShownImageNotes, setCurrShowImageNotes] = useState("")
    const [isEditingImage, setIsEditingImage] = useState(false)

    const notesField = useRef("")

    const openFileDialog = () => {
        var f = document.createElement('input');
        f.style.display='none';
        f.type='file';
        f.name='file';
        f.accept = '.png, .jpeg, .jpg'
        document.getElementById('intervention-edit-form-container').appendChild(f);
        f.click();
        f.addEventListener('change', () => {
            if (f.files) {
                var reader = new FileReader();
                reader.readAsDataURL(f.files[0]);
                reader.onload = async function() {
                    const base64 = reader.result;
                    setCurrShowImage(base64)
                    setTimeout(() => {
                        setShowNewImageModal(true)
                    }, 150);
                }
            }
        });
    }

    const openFileInNewWindow = async (photoData) => {
        if(loadingArray.includes(photoData.id)) return;
        setLoadingArray([...loadingArray, photoData.id])
        setCurrShowImage("")
        await iminioBackend.get_technical_intervention_photo(interventionId, photoData.id).then(response=>{
            // window.open(response.photo.base64)
            setTimeout(()=>{
                setCurrShowImage(response.photo.base64)
                setCurrShowImageId(response.photo.id)
                setCurrShowImageNotes(response.photo.notes)
                setLoadingArray(loadingArray.filter(e=>e!==photoData.id))
                setTimeout(()=>{setShowImageModal(true)},360)
            },370)
        })
    }

    const hideShowImageModal = async() => {
        setShowImageModal(false)
        setShowNewImageModal(false)
        setTimeout(() => {
            setCurrShowImage("")
        }, 150);
    }

    const onDeleteImageClick = async(photo) => {
        setImageToDelete(photo)
        setTimeout(() => {setShowDeleteModal(true)}, 150);
    }

    const hideDeleteImageModal = async(photo) => {
        setShowDeleteModal(false)
        setTimeout(() => {setImageToDelete("")}, 150);
    }

    const onEditImageNotesClick = async() => {
        setIsEditingImage(true)
    }

    const onEditImageNotesCancelEdit = async() => {
        notesField.current.value = currShownImageNotes
        setIsEditingImage(false)
    }

    const submitDeleteImage = async() => {
        await iminioBackend.delete_technical_intervention_photo(interventionId, imageToDelete.id).then(response=>{
            onDelete(imageToDelete)
            setTimeout(() => {hideDeleteImageModal() }, 300);
        }).catch(e=>console.log(e))
    }

    const submitAddImage = async() => {
        setIsNewImageLoading(true)
        await onClickUpload(currShownImage, notesField.current.value)
        setTimeout(() => {
            hideShowImageModal()
            setIsNewImageLoading(false)
        }, 360);
    }

    const submitEditImageNotes = async() => {
        setMessage("")
        setIsEditingLoading(true)
        await iminioBackend.edit_technical_intervention_photo_notes(interventionId, currShownImageId, notesField.current.value).then(response=>{
            setTimeout(()=>{
                setIsEditingLoading(false)
                setCurrShowImageNotes(notesField.current.value)
                setMessage("Nota modificata con Successo!")
                setIsEditingImage(false)
                setTimeout(() => {
                    setMessage("")
                }, 3200);
            },370)
        })
    }

    return <>
        <Modal show={showImageModal} onHide={()=>hideShowImageModal()}>
            <Modal.Header closeButton>
                <Modal.Title className="text-10">Intervento {interventionId}</Modal.Title>
            </Modal.Header>
            <div className="col col-12 p-3">
                <div className="row justify-center">
                    <img className="intervention-image" src={currShownImage} alt={`Intervento ${interventionId}`} />
                </div>
                <div className="row mt-3">
                    <span className="fg-orange"><b>Nota di foto</b></span>
                </div>
                <div className="row">
                    <Form.Control 
                        as="textarea" 
                        ref={notesField} 
                        className="p-2"
                        defaultValue={currShownImageNotes}
                        disabled={!isEditingImage}
                    />
                </div>
                <Row className="justify-content-end">
                    <Collapse in={message!=null&&message.length>0}>
                        <Row className="justify-content-center">
                            <Col id="sing-in-error-container" className="bg-green d-flex justify-content-center align-items-center py-1">
                                <span className="fg-white justify-content-center text-9">
                                    {message}
                                </span>
                            </Col>
                        </Row>
                    </Collapse>
                </Row>
                <div className="row mt-3 justify-content-end">

                    {
                    !enableEditPhotos? '' :
                    isEditingImage===false ? 
                    <Col xs={6} md={3}>
                        <Row className="justify-content-end">
                            <IminioButton 
                                label="Editare Nota" 
                                icon="mdi mdi-pencil" 
                                color="bg-orange" 
                                textColor="fg-white" 
                                size='sm'
                                disabled={isNewImageLoading}
                                onClick={()=>onEditImageNotesClick()}
                            />
                        </Row>
                    </Col>
                    :
                    <>
                        <Col xs={5} md={3} className="me-2">
                            <Row className="justify-content-center">
                                <IminioButton 
                                    label="Annullare" 
                                    icon="mdi mdi-close" 
                                    color="bg-gray" 
                                    textColor="fg-text" 
                                    size='sm'
                                    disabled={isEditingLoading}
                                    onClick={()=>onEditImageNotesCancelEdit()}
                                />
                            </Row>
                        </Col>
                        <Col xs={6} md={3}>
                            <Row className="justify-content-end">
                                <IminioButton 
                                    label="Salvare Nota" 
                                    icon="mdi mdi-content-save" 
                                    color="bg-orange" 
                                    textColor="fg-white" 
                                    size='sm'
                                    disabled={isEditingLoading}
                                    onClick={()=>submitEditImageNotes()}
                                />
                            </Row>
                        </Col>
                    </>
                    }
                </div>
            </div>
        </Modal>
        <Modal show={showNewImageModal} onHide={()=>hideShowImageModal()}>
            <Modal.Header closeButton>
                <Modal.Title className="text-10">Carica di Nuova Foto a Intervento {interventionId}</Modal.Title>
            </Modal.Header>
            <div className="col col-12 p-3">
                <div className="row justify-center" style={{maxHeight: '360px'}}>
                    <img className="intervention-image-small" src={currShownImage} alt={`Intervento ${interventionId}`} />
                </div>
                <div className="row mt-3">
                    <span className="fg-orange"><b>Nota di nuova foto</b></span>
                </div>
                <div className="row">
                    <Form.Control 
                        as="textarea" 
                        ref={notesField} 
                        className="p-2"
                    />
                </div>
                <div className="row mt-3 justify-content-between">
                    <Col xs={6} md={4}>
                        <IminioButton 
                            label="Annulare" 
                            icon="mdi mdi-close" 
                            color="bg-gray" 
                            textColor="fg-text" 
                            size='sm'
                            disabled={isNewImageLoading}
                            onClick={()=>hideShowImageModal()}
                        />
                    </Col>
                    <Col xs={6} md={4}>
                        {isNewImageLoading===true && <i className="mdi mdi-loading mdi-spin"></i> }
                        <Row className="justify-content-end">
                            <IminioButton 
                                label="Aggiungere" 
                                icon="mdi mdi-upload" 
                                color="bg-orange" 
                                textColor="fg-white" 
                                size='sm'
                                disabled={isNewImageLoading}
                                onClick={()=>submitAddImage()}
                            />
                        </Row>
                    </Col>
                </div>
            </div>
        </Modal>
        <Modal show={showDeleteModal} onHide={()=>hideDeleteImageModal()}>
            <Modal.Header closeButton>
                <Modal.Title className="text-10">Eliminare la foto dell'intervento?</Modal.Title>
            </Modal.Header>
            <div className="col col-12 p-3" style={{width:'360px'}}>
                <div className="row justify-center" style={{maxHeight: '360px'}}>
                    <img className="intervention-image" src={imageToDelete.thumbnail} alt={`Intervento ${interventionId}`} />
                </div>
                <div className="row align-items-center mt-3">
                    <div className="col col-xs-12 col-md-6 px-3">
                        <div className="row justify-content-center">
                            <IminioButton 
                                label="Eliminare" 
                                icon="mdi mdi-delete" 
                                color="bg-red" 
                                textColor="fg-white" 
                                size='sm'
                                onClick={()=>submitDeleteImage()}
                            />
                        </div>
                    </div>
                    <div className="col col-xs-12 col-md-6 px-3">
                        <div className="row justify-content-center">
                            <IminioButton 
                                label="Annullare" 
                                icon="mdi mdi-close" 
                                color="bg-gray" 
                                textColor="fg-text" 
                                size='sm'
                                onClick={()=>hideDeleteImageModal()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
        {
            !photos || photos.length === 0 ?
                <Button className={`iminio-button px-3 corner-round bg-blue fg-white text-9`} variant="primary" onClick={openFileDialog} size={'lg'} disabled={!enableEditPhotos}>
                    <i className="mdi mdi-upload text-11 me-2"></i>
                    Carica Foto
                </Button>
            :
            ''
        }
         {
            photos?.length === 1 ?
                <Row className="justify-content-center align-items-center align-content-center">
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[0].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[0])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[0].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[0])}/>
                    </Col>
                    <Col xs={6} className="pa-2 d-flex align-content-center justify-content-center">
                        <Button className={`iminio-button px-3 corner-round bg-blue fg-white text-9`} variant="primary" onClick={openFileDialog} size={'lg'} disabled={!enableEditPhotos}>
                            <i className="mdi mdi-upload text-11 me-2"></i>
                            Carica Foto
                        </Button>
                    </Col>
                </Row>
            :
            ''
        }
        {
            photos?.length === 2 ?
                <Row className="justify-content-center align-items-center align-content-center">
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[0].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[0])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[0].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[0])}/>
                    </Col>
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[1].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[1])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[1].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[1])}/>
                    </Col>
                    <Col xs={12} className="pa-2 d-flex align-content-center justify-content-center">
                        <Button className={`iminio-button px-3 corner-round bg-blue fg-white text-9`} variant="primary" onClick={openFileDialog} size={'lg'} disabled={!enableEditPhotos}>
                            <i className="mdi mdi-upload text-11 me-2"></i>
                            Carica Foto
                        </Button>
                    </Col>
                </Row>
            :
            ''
        }
         {
            photos?.length === 3 ?
                <Row className="justify-content-center align-items-center align-content-center">
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[0].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[0])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[0].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[0])}/>
                    </Col>
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[1].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[1])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[1].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[1])}/>
                    </Col>
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[2].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[2])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[2].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[2])}/>
                    </Col>
                    <Col xs={6} className="pa-2 d-flex align-content-center justify-content-center">
                        <Button className={`iminio-button px-3 corner-round bg-blue fg-white text-9`} variant="primary" onClick={openFileDialog} size={'sm'} disabled={!enableEditPhotos}>
                            <i className="mdi mdi-upload text-11 me-2"></i>
                            Carica Foto
                        </Button>
                    </Col>
                </Row>
            :
            ''
        }
         {
            photos?.length === 4 ?
                <Row className="justify-content-center align-items-center align-content-center">
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[0].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[0])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[0].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[0])}/>
                    </Col>
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[1].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[1])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[1].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[1])}/>
                    </Col>
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[2].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[2])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[2].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[2])}/>
                    </Col>
                    <Col xs={6} className="intervention-photo-container-small">
                        {!loadingArray.includes(photos[3].id) ? '' : 
                        <div className="intervention-photo-container-loading">
                            <i className="mdi mdi-loading mdi-spin text-20 fg-orange"></i>
                        </div>}
                        {!enableDelete ? '' : 
                            <div className="intervention-photo-container-delete" onClick={()=>onDeleteImageClick(photos[3])}>
                                <i className="mdi mdi-delete text-14 fg-red"></i>
                            </div>
                        }
                        <img  src={` data:image/jpeg;charset=utf-8; ${photos[3].thumbnail}`} alt="" onClick={()=>openFileInNewWindow(photos[3])}/>
                    </Col>
                </Row>
            :
            ''
        }
    </>
}

export default IminioInterventionPhotoButton